/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Detail_View_DetailsInputs */

const es_chat_tool_detail_view_details = /** @type {(inputs: Chat_Tool_Detail_View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver detalles`)
};

const en_chat_tool_detail_view_details = /** @type {(inputs: Chat_Tool_Detail_View_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View details`)
};

/**
* | output |
* | --- |
* | "View details" |
*
* @param {Chat_Tool_Detail_View_DetailsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_view_details = /** @type {((inputs?: Chat_Tool_Detail_View_DetailsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_View_DetailsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_view_details(inputs)
	return en_chat_tool_detail_view_details(inputs)
});
export { chat_tool_detail_view_details as "chat.tool_detail.view_details" }